module.exports = __webpack_public_path__ + "static/linkedin-4da503a6b4867bde80d2b418b2749cea.png";